<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9394 15.9629H22.0545M13.9394 15.9629C13.9394 18.2047 15.7551 20.0205 17.997 20.0205M13.9394 15.9629C13.9394 13.7211 15.7551 11.9053 17.997 11.9053M22.0545 15.9629C22.0545 18.2047 20.2388 20.0205 17.997 20.0205M22.0545 15.9629C22.0545 13.7211 20.2388 11.9053 17.997 11.9053M17.997 20.0205C17.155 20.0205 16.4754 18.2047 16.4754 15.9629C16.4754 13.7211 17.155 11.9053 17.997 11.9053M17.997 20.0205C18.8389 20.0205 19.5186 18.2047 19.5186 15.9629C19.5186 13.7211 18.8389 11.9053 17.997 11.9053M14.4364 3.79013H11.6874C11.2208 3.79013 10.815 4.10459 10.7035 4.556L10.1963 6.58479C10.1202 6.88911 10.1861 7.20864 10.3789 7.45717C10.5716 7.7057 10.8658 7.84771 11.1802 7.84771H11.4034M3.62298 14.2993L4.30262 10.8909H5.03299C5.34745 10.8909 5.64163 10.7489 5.83436 10.5004C6.0271 10.2518 6.09303 9.93229 6.01695 9.62798L5.50976 7.59918C5.39817 7.14778 4.99241 6.83332 4.52579 6.83332H0.904399M9.90715 15.8107C5.79378 16.6628 1.76156 14.0203 0.909468 9.90186C0.0573762 5.78342 2.70495 1.75627 6.8234 0.909246C10.9418 0.0571541 14.9639 2.7098 15.8109 6.82824M13.9394 8.86211H22.0545C22.0545 8.86211 24.0833 8.86211 24.0833 10.8909V22.0492C24.0833 22.0492 24.0833 24.078 22.0545 24.078H13.9394C13.9394 24.078 11.9106 24.078 11.9106 22.0492V10.8909C11.9106 10.8909 11.9106 8.86211 13.9394 8.86211Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
